<template>
  <div>

    <v-container>

      <v-row>
        <v-col md="3">
          <KTCard title="ذخیره سازی">


            <template #title>
              <div class="d-flex align-items-center">
                <span class="flaticon2-check-mark mr-3 font-size-h4"></span>
                <h4>ذخیره سازی</h4>
              </div>
            </template>

            <template #body>
              <b-row>
                <b-col md="6" class="py-0">
                  <b-button class="d-flex align-items-center w-100 justify-content-center">
                    <b-icon-x-circle/>
                    <span class="ml-4 font-size-h5">لغو</span>
                  </b-button>
                </b-col>
                <b-col md="6" class="py-0">
                  <b-button variant="success" class="d-flex align-items-center w-100 justify-content-center">
                    <b-icon-check-circle/>
                    <span class="ml-4 font-size-h5">تایید</span>
                  </b-button>
                </b-col>
                <b-col md="6"></b-col>
              </b-row>
            </template>
          </KTCard>
          <KTCard title="تنظیمات">

            <template #title>
              <div class="d-flex align-items-center">
                <span class="flaticon-cogwheel-2 mr-3 font-size-h4"></span>
                <h4>تنظیمات</h4>
              </div>
            </template>

            <template #body>
              <div class="d-flex align-items-center">
                <label class="mr-3 mb-0 font-weight-bold font-size-h5">نمایش در صفحه فیلتر :</label>
                <span dir="ltr" class="">
                  <b-form-checkbox size="lg" switch/>
                </span>
              </div>
            </template>

          </KTCard>
        </v-col>
        <v-col md="9">
          <KTCard title="اطلاعات">
            <template #title>
              <div class="d-flex align-items-center">
                <span class="flaticon2-information mr-3 font-size-h4"></span>
                <h4>اطلاعات</h4>
              </div>
            </template>


            <template #body>
              <b-row>
                <b-col md="6">
                  <label class="font-weight-bold">نام : <span class="text-danger">*</span></label>
                  <b-form-input type="text" placeholder="نام"/>
                </b-col>
                <b-col md="6">
                  <label class="font-weight-bold">نام مستعار : </label>
                  <b-form-input type="text" placeholder="نام مستعار"/>
                </b-col>
                <b-col md="12">
                  <label class="font-weight-bold">توضیحات : </label>
                  <b-form-textarea placeholder="توضیحات"/>
                </b-col>
              </b-row>
            </template>

          </KTCard>
        </v-col>
      </v-row>

    </v-container>

  </div>
</template>

<script>
import KTCard from "../../content/Card";
export default {
  name: "Create",
  components: {KTCard}
}
</script>

<style scoped>

</style>
